import React from 'react'

export default function CreateRequestButton(props) {
  return (
    <button
      type="button"
      onClick={props.setCreatingNew}
      className="w-full border border-dashed border-mauve-300 bg-mauve-100 py-6 text-center text-sm font-semibold tracking-wide text-mauve-700 transition hover:border-mauve-500 hover:bg-mauve-200"
    >
      CREATE REQUEST
    </button>
  )
}
